<template>
  <div
    class="popup_wrap"
    style="width:600px;height:600px;overflow-y: hidden"
  >
    <button
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <!-- 운임 >> 나의 운임 -->
    <div class="popup_cont">
      <e-breadcrumbs />

      <div class="content_box mt10">
        <div class="flex_box">
          <span style="width: 90%; float: left; color: #075bb9; font-weight: 500; font-size: 17px; margin-left: 10px;">R/A (S/C) No : {{ raNo }} <span style="font-size: 15px; color: red;"> {{ negoAfterText }} </span></span>
        </div>
        <table class="tbl_search">
          <colgroup>
            <col width="100px">
            <col width="50px">
            <col width="50px">
            <col width="50px">
            <col width="50px">
            <col width="100px">
            <col width="100px">
          </colgroup>
          <tbody>
            <tr><th></th></tr>
            <tr>
              <th>POR (국가)</th>
              <td colspan="4">
                <input type="text" id="porPlcNm" v-model="porPlcNm" readonly />
              </td>
              <td colspan="4">
                <input type="text" id="porCtrNm" v-model="porCtrNm" readonly />
              </td>
            </tr>
            <tr>
              <th>DLY (국가)</th>
              <td colspan="4">
                <input type="text" id="dlyPlcNm" v-model="dlyPlcNm" readonly />
              </td>
              <td colspan="4">
                <input type="text" id="dlyCtrNm" v-model="dlyCtrNm" readonly />
              </td>
            </tr>
            <tr>
              <th>운임유효기간</th>
              <td colspan="4">
                <input type="text" id="freExpDate" v-model="freExpDate" readonly />
              </td>
            </tr>
            <br />
            <tr>
              <td colspan="10">
                <div style="font-size: 16px;">
                  KMTC ON NOW를 이용해서 운임을 협의해보세요.<br />
                  하기 정보를 입력해주시면 즉시 협의된 운임을 확인하실 수 있습니다.<br />
                  <br />
                  (요청해주신 IDEAL RATE 수준에 따라 <br />
                  &nbsp;원하시는 협의 운임이 도출되지 않을 수 있는 점 양해 부탁드립니다.) <br />
                </div>
              </td>
            </tr>
            <br />
            <tr>
              <th>실화주</th>
              <td colspan="5">
                <input type="text" id="actShpNm" v-model="actShpNm" />
              </td>
            </tr>
            <tr>
              <th>IDEAL RATE</th>
              <th colspan="2">20FT (USD)</th>
              <td colspan="3">
                <e-input-number id="req20Ft" v-model="req20Ft" />
              </td>
            </tr>
            <tr>
              <th></th>
              <th colspan="2">40FT (USD)</th>
              <td colspan="3">
                <e-input-number id="req40Ft" v-model="req40Ft" />
              </td>
            </tr>
            <tr><th></th></tr>
            <tr>
              <th></th>
              <td colspan="6">
                <input type="checkbox" id="lssYn" name="lssYn" v-model="lssYn" true-value="Y" false-value="N" />
                <label for="lssYn" class="mr10"><span></span>선적지 LSS 포함 기준으로 IDEAL RATE를 제출하겠습니다.(선택)</label>
                <br />
              </td>
            </tr>
            <tr><th></th><td></td></tr>
            <tr><th></th><td></td></tr>
            <tr>
              <td colspan="7" class="text_right">
                <a class="button blue sh" href="#" @click.prevent="kmtcOnNegoRequest()">KMTC ON NOW 운임 협의하기</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
    </div>
  </div>
</template>

  <script>
  import commons from '@/api/services/commons'
  import EAutoCompletePlace from '@/components/common/EAutoCompletePlace'
  import EInputNumber from '@/components/common/EInputNumber'
  import schedule from '@/api/rest/schedule/schedule'
  import { rootComputed } from '@/store/helpers'
  import EBreadcrumbs from '@/components/common/EBreadcrumbs.vue'

  export default {
    name: 'KmtcOnPremiumPop',
    components: {
      EBreadcrumbs,
      EAutoCompletePlace,
      EInputNumber
    },
    props: {
      parentInfo: {
        type: Object,
        default: function () {
          return {
            raNo: '',
            scNo: '',
            porCtrNm: '',
            porPlcNm: '',
            dlyCtrNm: '',
            dlyPlcNm: '',
            freExpDate: '',
            porCtrCd: '',
            dlyCtrCd: '',
            porPlcCd: '',
            dlyPlcCd: '',
            frtPncNm: '',
            apv20Ft: '',
            apv40Ft: ''
          }
        }
      }
    },
    data () {
      return {
        gridHeight: 510,
        customComponent: null,
        params: {
          raNo: '',
          scNo: '',
          porCtrNm: '',
          porPlcNm: '',
          dlyCtrNm: '',
          dlyPlcNm: '',
          freExpDate: '',
          dlyCtrCd: '',
          frtPncNm: '',
          apv20Ft: '',
          apv40Ft: ''
        },
        isSearch: false,
        format: 'YYYY.MM.DD',
        myOceanFreightList: [],
        // 운임 팝업을 띄우기 위해 필요한 데이터
        surChargeParams: {},
        dtChk: true,
        serviceCtrCd: '',
        relYn: true, // JamSin
        raNo: '',
        scNo: '',
        porCtrNm: '',
        porPlcNm: '',
        dlyCtrNm: '',
        dlyPlcNm: '',
        freExpDate: '',
        actShpNm: '',
        req20Ft: '', // 20FT 요청 금액
        req40Ft: '', // 40FT 요청 금액
        apv20FtList: [], // 20FT 승인 금액 리스트
        apv40FtList: [], // 40FT 승인 금액 리스트
        apv20Ft: '',
        apv40Ft: '',
        porCtrCd: '',
        dlyCtrCd: '', // 도착지 국가 코드
        dlyCtrLssYn: '', // 도착지 국가 LSS 대상 여부
        lssYn: 'Y', // LSS 포함 여부
        negoAfterText: '',
        frtPncNm: '',
        porPlcCd: '',
        dlyPlcCd: ''
      }
    },
    computed: {
      ...rootComputed
    },
    created () {
      this.raNo = this.parentInfo.raNo
      this.scNo = this.parentInfo.scNo
      this.porCtrNm = this.parentInfo.porCtrNm
      this.porPlcNm = this.parentInfo.porPlcNm
      this.dlyCtrNm = this.parentInfo.dlyCtrNm
      this.dlyPlcNm = this.parentInfo.dlyPlcNm
      this.freExpDate = this.parentInfo.freExpDate
      this.porCtrCd = this.parentInfo.porCtrCd
      this.dlyCtrCd = this.parentInfo.dlyCtrCd
      this.porPlcCd = this.parentInfo.porPlcCd
      this.dlyPlcCd = this.parentInfo.dlyPlcCd
      this.frtPncNm = this.parentInfo.frtPncNm
      this.apv20Ft = this.parentInfo.apv20Ft
      this.apv40Ft = this.parentInfo.apv40Ft
    },
    methods: {
      // KMTC ON NEGO 제출
      async kmtcOnNegoRequest () {
        if (this.raNo.length < 1) {
          this.$ekmtcCommon.asyncAlertMessage({ message: '네고 요청할 운임을 선택하세요.' })
          return
        }

        if (this.actShpNm.length < 1) {
          this.$ekmtcCommon.asyncAlertMessage({ message: '실화주를 입력하세요.' })
          return
        }

        if (this.req20Ft < 1 || this.req40Ft < 1) {
          this.$ekmtcCommon.asyncAlertMessage({ message: '운임을 입력하세요.' })
          return
        }

        if (this.negoAfterText !== '') {
          this.$ekmtcCommon.asyncAlertMessage({ message: '네고 완료된 운임입니다.' })
          return
        }

        // 중국, 홍콩, 대만은 LSS 미포함
        if (this.dlyCtrCd === 'CN' || this.dlyCtrCd === 'HK' || this.dlyCtrCd === 'TW') {
          this.dlyCtrLssYn = 'N'
        } else {
          this.dlyCtrLssYn = 'Y'
        }

        // Nego 로직 시작
        this.surChargeParams = Object.assign({}, this.surChargeParams, { frtAppNo: this.raNo })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { actShpNm: this.actShpNm })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { req20Ft: this.req20Ft })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { req40Ft: this.req40Ft })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { apv20Ft: this.apv20Ft })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { apv40Ft: this.apv40Ft })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { lssYn: this.lssYn })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { dlyCtrLssYn: this.dlyCtrLssYn })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { frtPncCd: this.frtPncNm })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { negoStepChk: '1step' })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { porPlcCd: this.porPlcCd })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { porCtrCd: this.porCtrCd })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { dlyPlcCd: this.dlyPlcCd })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { dlyCtrCd: this.dlyCtrCd })
        this.surChargeParams = Object.assign({}, this.surChargeParams, { fromDt: this.freExpDate.replaceAll('/', '').substring(0, 8) })

        let errChk = false
        let msg = null

        await schedule.kmtcOnNegoRequest(this.surChargeParams).then((response) => {
          if (response.data !== '') {
            if (response.data.negoYN === 'L' || response.data.negoYN === 'M') {
              msg = response.data.negoYN
              this.$ekmtcCommon.asyncAlertMessage({ message: response.data.lssPc })
              return
            }

            this.params.frtAppNo = response.data.frtAppNo

            if (response.data.negoYN === 'R' || response.data.negoYN === 'K') {
              msg = response.data.lssPc
            } else if (response.data.negoYN === 'X') {
              msg = response.data.lssPc
              this.negoAfterText = '해당 SC No. 운임이 가장 저렴한 운임입니다.'
              this.$ekmtcCommon.asyncAlertMessage({ message: msg })
              msg = response.data.negoYN // X인 경우 세팅
            }
          } else {
            errChk = true
          }
        })

        // X는 현재 RA가 최저 운임, L은 요청운임 기준 미달, M은 1st min. 설정 누락
        if (msg === 'X' || msg === 'L' || msg === 'M') return

        if (!errChk) {
          // 화주에게 운임 할인 진행할지 확인 메세지 출력
          if (!await this.$ekmtcCommon.asyncAlertMessage({ message: msg, useConfirmBtn: true })) {
            return
          }

          // 2step은 운임할인 로직 실행하여 신규 운임 생성하는 단계
          this.surChargeParams = Object.assign({}, this.surChargeParams, { negoStepChk: '2step' })

          // 2step 세팅하여 운임할인 로직 호출
          await schedule.kmtcOnNegoRequest(this.surChargeParams).then((response) => {
            if (response.data !== '') {
              if (response.data.negoYN === 'L' || response.data.negoYN === 'M') {
                this.$ekmtcCommon.asyncAlertMessage({ message: response.data.lssPc })
                return
              }

              this.params.frtAppNo = response.data.frtAppNo

              if (response.data.negoYN === 'R' || response.data.negoYN === 'K') {
                msg = '운임 조정이 완료되었습니다. 부킹 후 S/R 제출 시 조정된 운임이 자동으로 반영됩니다.'
                this.negoAfterText = '네고완료! 리스트의 SC번호 클릭하여 확인하세요.'
              }

              this.params.kind = 'N' // 일반 검색과 구분하기 위해 네고 완료 구분자를 세팅하고, 아래 검색시 체크함
              this.$ekmtcCommon.asyncAlertMessage({ message: msg }).then(() => {
                this.params.kind = 'R' // 일반 검색 구분자(요청일자)
                this.$emit('close')
              })
            }
          })
        } else { // 화주 등급 또는 최저 운임 설정이 없이 진행이 불가능한 경우 디지털세일즈팀에게 메일 발송함
          if (await this.$ekmtcCommon.asyncAlertMessage({ message: '해당 구간의 운임은 아직 조정이 어렵습니다. 담당 직원에게 문의하시겠습니까?', useConfirmBtn: true })) {
            // 메일 내용에 필요한 담당 영업 사원 정보 조회..였으나, 송민섭씨 요청에 의해 영업사원 정보는 제외함.
            // let salesEmail = ''
            // let salesName = ''
            //
            // await schedule.selectSalesMan().then((response) => {
            //   if (response.data !== '') {
            //     response.data.forEach(i => {
            //       salesName += i.salesName + '(' + i.eiCatCd + ') / '
            //       salesEmail += i.salesEmail + ' / '
            //     })
            //     salesName = salesName.slice(0, -2)
            //     salesEmail = salesEmail.slice(0, -2)
            //   }
          // })

            // 운임 할인에 필요한 화주 등급 데이터가 없거나, 최저 운임 데이터가 없는 경우 위 메세지가 노출되고, 이후 kmtcon@ekmtc.com 계정으로 메일을 발송함
            msg = '화주 코드 : ' + this.auth.cstCd + '<br>' +
                  '화주 명 : ' + this.memberDetail.compEname + '<br>' +
                  '구간 : ' + this.surChargeParams.porPlcCd + ' - ' + this.surChargeParams.dlyPlcCd + '<br>' +
                  '기간 : ' + this.freExpDate + '<br>' +
                  '담당자 이름 : ' + this.auth.userName + '<br>' +
                  '담당자 이메일 : ' + this.selectedProfile.emlAddr + '<br>' +
                  '담당자 전화번호 : ' + this.memberDetail.cel1 + '-' + this.memberDetail.cel2 + '-' + this.memberDetail.cel3

            const formData = new FormData()
            formData.append('toEmail', 'kmtcon@ekmtc.com')
            formData.append('fromEmail', 'eKMTC@kmtcOnNow.menu')
            formData.append('subject', 'KMTC ON NOW 운임 문의')
            formData.append('message', msg)

            await commons.sendEmail(formData).then((response) => {
              this.$ekmtcCommon.asyncAlertMessage({ message: '담당 직원에게 해당 구간 문의 메일이 발송되었습니다.' })
            })
          }
        }
      },
      layerClose () {
        this.$emit('close')
      }
    }
  }
  </script>
